import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2';
import { PanelDetailMaintenanceComponent } from 'src/app/cell-renderer/panel-detail-maintenance/panel-detail-maintenance.component';
import { ColDef, GridApi, ICellRendererParams } from 'ag-grid-community';

// Import JSZip and file-saver using require syntax to avoid module issues
declare const require: any;
const JSZip = require('jszip');
const fileSaver = require('file-saver');

// Interfaces for API responses
interface ApiResponse<T> {
    success: boolean;
    data: T;
}

interface MaintenanceStatus {
    id: number;
    name: string;
    color?: string;
    text_color?: string;
}

import { ActionMaintenanceComponent } from 'src/app/cell-renderer/action-maintenance/action-maintenance.component';
import { MaintenanceService } from 'src/app/services/maintenance.service';
import { QuotesService } from 'src/app/services/quotes.service';
import { UnitService } from 'src/app/services/unit.service';
import { environment } from 'src/environments/environment';
import { PermissionService } from 'src/app/services/permission.service';
import { UtilsService } from 'src/app/services/utils.service';
import { PriorityService } from 'src/app/services/priority.service';
declare var $: any;

@Component({
    selector: 'app-maintenance-list',
    templateUrl: './maintenance-list.component.html',
    styleUrls: ['./maintenance-list.component.css']
})
export class MaintenanceListComponent {

    constructor(
        private spinner: NgxSpinnerService,
        private maintenanceService: MaintenanceService,
        private quotesService: QuotesService,
        private fb: FormBuilder,
        private unitService: UnitService,
        private permissionService: PermissionService,
        private utilsService: UtilsService,
        private priorityService: PriorityService,
        private route: ActivatedRoute
    ) { }

    public pageSize = 25
    public pageSizeOptions: number[] = [25, 50, 100, 200]
    public currentPage = 1
    public hasNextPage = false

    urlPage = environment.url_page

    private gridApi!: GridApi

    columnDefs: any = []
    defaultColDef: any = {
        sortable: true,
        flex: 1,
        filter: false,
        resizable: true,
        suppressMovable: true,
        suppressHeaderMenuButton: true,
    };

    public tooltipShowDelay = 0;
    public tooltipHideDelay = 10000;

    private baseRows: any[] = [];
    private expandedIds = new Set<any>();
    paymentType: any = [];
    paymentMethod: any = [];
    paymentForm!: FormGroup;
    filterForm!: FormGroup;
    isPartial = false;
    amountMask: any = { mask: Number, scale: 2, thousandsSeparator: '.', radix: ',', normalizeZeros: true, padFractionalZeros: true };
    selectedEvidenceFile: File | null = null;
    evidenceFileUrl: string | null = null;
    selectedPaymentInvoiceFile: File | null = null;
    paymentInvoiceFileUrl: string | null = null;

    statusMaintenanceAdministrative: MaintenanceStatus[] = [];
    statusMaintenanceSupervisor: MaintenanceStatus[] = [];
    statusMaintenanceDirection: any = [];
    units: any = [];
    selectedStatusId: number | null = null;
    selectedStatusForDisplay: MaintenanceStatus | null = null;
    maintenanceType: any = [];
    statusMaintenance: any = [];
    unitStatistics: any = {
        criticas: 0,
        en_reparacion: 0,
        pendientes: 0,
        programadas: 0,
        finalizadas: 0
    };
    role: any = {};
    priority: any = [];
    showFilters = false;

    private get isResponsive(): boolean {
        return window.innerWidth <= 1024;
    }

    private applyGridSizing(): void {
        if (!this.gridApi) return;
        if (this.isResponsive) {
            this.gridApi.setGridOption('defaultColDef', { ...this.defaultColDef, flex: 0, minWidth: 100 });
            setTimeout(() => { if (this.gridApi) this.gridApi.autoSizeAllColumns(false); }, 200);
        } else {
            this.gridApi.setGridOption('defaultColDef', { ...this.defaultColDef, flex: 1 });
            this.gridApi.sizeColumnsToFit();
        }
    }

    @HostListener('window:resize')
    onWindowResize(): void {
        this.applyGridSizing();
    }
    public getRowHeight(params: any) {
        // Let the child detail-panel measure and set the exact height via ResizeObserver.
        // We only return a small baseline for initial render; it will be overridden.
        if (params?.data?.__isDetail) {
            return 160; // baseline before auto-resize kicks in
        }
        // Master rows keep compact height
        return 48;
    }

    async ngOnInit() {

        forkJoin([
            this.quotesService.getPaymentType(),
            this.maintenanceService.getPaymentMethod(),
            this.maintenanceService.getMaintenanceStatusAdministrative(),
            this.maintenanceService.getMaintenanceStatusSupervisor(),
            this.unitService.getInfo(),
            this.maintenanceService.getMaintenanceType(),
            this.maintenanceService.getMaintenanceStatus(),
            this.maintenanceService.getMaintenanceStatusDirection(),
            this.priorityService.getData()
        ]).subscribe({
            next: ([resp1, resp2, resp3, resp4, resp5, resp6, resp7, resp8, resp9]) => {
                this.paymentType = (resp1 as ApiResponse<any>);
                this.paymentMethod = (resp2 as ApiResponse<any>);
                this.statusMaintenanceAdministrative = (resp3 as ApiResponse<MaintenanceStatus[]>).data;
                this.statusMaintenanceSupervisor = (resp4 as ApiResponse<MaintenanceStatus[]>).data;
                this.units = (resp5 as ApiResponse<any>);
                this.maintenanceType = (resp6 as ApiResponse<any>);
                this.statusMaintenance = (resp7 as ApiResponse<any>);
                this.statusMaintenanceDirection = (resp8 as ApiResponse<any>);
                this.priority = (resp9 as ApiResponse<any>);
            },
            error: (err: any) => {
            },
            complete: () => {
                this.role = this.permissionService.getRole();
                this.getListMaintenance()
            }
        })
        this.initPaymentForm();
        this.initFilterForm();
    }

    private datepickersInitialized = false;
    ngAfterViewChecked(): void {
        if (this.datepickersInitialized) return;
        try {
            const uploadExists = typeof $ !== 'undefined' && $("#date_repair").length > 0;
            const downloadExists = typeof $ !== 'undefined' && $("#request_date").length > 0;
            if (uploadExists || downloadExists) {
                this.initDatepickers();
                this.datepickersInitialized = true;
            }
        } catch { }
    }

    refreshGrid(){
        this.buildDatasource()
    }

    removeDate(id: string) {
        const $el = $("#" + id);
        if (!$el.length || !$.fn || !$.fn.datepicker) {
            this.filterForm.get(id)?.setValue('');
            this.buildDatasource();
            return;
        }
        $el.datepicker('setDate', null).trigger("change");
        $el.datepicker('hide');
    }

    private initDatepickers(): void {
        try {
            if (!$.fn || !$.fn.datepicker) {
                console.warn('jQuery UI datepicker is not loaded. Ensure jQuery UI JS and CSS are included.');
                return;
            }

            const dpOptions = { dateFormat: 'dd/mm/yy', appendTo: 'body' };

            const $requestDate = $("#request_date");
            if ($requestDate.length) {
                $requestDate.datepicker({ ...dpOptions, onSelect: () => $requestDate.trigger('change') })
                    .change(() => {
                        const parsed = $.datepicker.parseDate('dd/mm/yy', $requestDate.datepicker({ dateFormat: 'yy-mm-dd' }).val());
                        this.filterForm.get('request_date')!.setValue($.datepicker.formatDate('yy-mm-dd', parsed));
                        this.buildDatasource();
                    });
            }

            const $dateRepair = $("#date_repair");
            if ($dateRepair.length) {
                $dateRepair.datepicker({ ...dpOptions, onSelect: () => $dateRepair.trigger('change') })
                    .change(() => {
                        const parsed = $.datepicker.parseDate('dd/mm/yy', $dateRepair.datepicker({ dateFormat: 'yy-mm-dd' }).val());
                        this.filterForm.get('date_repair')!.setValue($.datepicker.formatDate('yy-mm-dd', parsed));
                        this.buildDatasource();
                    });
            }

            const $datePayment = $("#date_payment");
            if ($datePayment.length) {
                $datePayment.datepicker({ ...dpOptions, onSelect: () => $datePayment.trigger('change') })
                    .change(() => {
                        const parsed = $.datepicker.parseDate('dd/mm/yy', $datePayment.datepicker({ dateFormat: 'yy-mm-dd' }).val());
                        this.filterForm.get('date_payment')!.setValue($.datepicker.formatDate('yy-mm-dd', parsed));
                        this.buildDatasource();
                    });
            }

            this.datepickersInitialized = true;
        } catch (e) {
            console.error('Failed to initialize datepickers', e);
        }
    }

    private initFilterForm() {
        this.filterForm = this.fb.group({
            request_date: ['', Validators.required],
            unit_id: ['', Validators.required],
            date_repair: ['', Validators.required],
            maintenance_type_id: ['', Validators.required],
            maintenance_status_id: ['', Validators.required],
            payment_method_id: ['', Validators.required],
            payment_type_id: ['', Validators.required],
            folio: ['', Validators.required],
            date_payment: ['', Validators.required],
            priority_id: ['', Validators.required],
        });

        const unitIdParam = this.route.snapshot.queryParamMap.get('unit_id');
        if (unitIdParam) {
            this.filterForm.get('unit_id')!.setValue(unitIdParam);
        }

        this.filterForm.get('request_date')!.valueChanges.subscribe(() => {
            this.buildDatasource();
        });
        this.filterForm.get('unit_id')!.valueChanges.subscribe(() => {
            this.buildDatasource();
        });
        this.filterForm.get('date_repair')!.valueChanges.subscribe(() => {
            this.buildDatasource();
        });
        this.filterForm.get('maintenance_type_id')!.valueChanges.subscribe(() => {
            this.buildDatasource();
        });
        this.filterForm.get('maintenance_status_id')!.valueChanges.subscribe(() => {
            this.buildDatasource();
        });
        this.filterForm.get('payment_method_id')!.valueChanges.subscribe(() => {
            this.buildDatasource();
        });
        this.filterForm.get('payment_type_id')!.valueChanges.subscribe(() => {
            this.buildDatasource();
        });
        this.filterForm.get('folio')!.valueChanges.subscribe(() => {
            this.buildDatasource();
        });
        this.filterForm.get('date_payment')!.valueChanges.subscribe(() => {
            this.buildDatasource();
        });
        this.filterForm.get('priority_id')!.valueChanges.subscribe(() => {
            this.buildDatasource();
        });
    }


    private initPaymentForm() {
        this.paymentForm = this.fb.group({
            maintenance_request_id: [null],
            payment_method_id: ['', Validators.required],
            payment_type_id: ['', Validators.required],
            payment_amount: [{ value: '', disabled: false }],
            partial_percentage: [{ value: null, disabled: false }, [Validators.required, Validators.min(1), Validators.max(100)]],
            remaining_amount: [{ value: null, disabled: false }, Validators.required],
            settlement_date: [{ value: null, disabled: false }, Validators.required],
            evidence_file: [null, this.typeFormPayment === 2 ? Validators.required : null],
        });

        const typeCtrl = this.paymentForm.get('payment_type_id')!;
        const amountCtrl = this.paymentForm.get('payment_amount')!;
        const percentCtrl = this.paymentForm.get('partial_percentage')!;
        const remainingCtrl = this.paymentForm.get('remaining_amount')!;
        const dateCtrl = this.paymentForm.get('settlement_date')!;

        const togglePartialFields = () => {
            const isType1 = Number(typeCtrl.value) === 1;
            const amtVal = this.paymentForm.get('payment_amount')?.value;
            const hasAmount = amtVal !== null && amtVal !== '' && !isNaN(Number(amtVal));

            if (isType1 && hasAmount) {
                percentCtrl.enable({ emitEvent: false });
                remainingCtrl.enable({ emitEvent: false });
            } else {
                percentCtrl.disable({ emitEvent: false });
                remainingCtrl.disable({ emitEvent: false });
            }
        };

        typeCtrl.valueChanges.subscribe((val) => {
            const isType1 = Number(val) == 1;

            if (isType1) {
                togglePartialFields();
                // Only these are required
                percentCtrl.setValidators([Validators.required, Validators.min(1), Validators.max(100)]);
                remainingCtrl.setValidators([Validators.required]);
            } else {
                percentCtrl.reset();
                remainingCtrl.setValue('', { emitEvent: false });
                amountCtrl.clearValidators();
                percentCtrl.clearValidators();
                remainingCtrl.clearValidators();
                percentCtrl.disable({ emitEvent: false });
                remainingCtrl.disable({ emitEvent: false });
            }
            percentCtrl.updateValueAndValidity({ emitEvent: false });
            remainingCtrl.updateValueAndValidity({ emitEvent: false });
        });
        const recalcFromPercentage = () => {
            const isType1 = Number(typeCtrl.value) === 1;
            if (!isType1) return;
            const amt = Number(this.paymentForm.get('payment_amount')?.value ?? 0) || 0;
            const perc = Number(percentCtrl.value ?? 0);
            // Clamp percentage 0..100
            const clampedPerc = Math.max(0, Math.min(100, perc));
            if (perc !== clampedPerc) percentCtrl.setValue(clampedPerc, { emitEvent: false });
            // NOW: percentage refers to the PAID percentage, so remaining = total - (total * paid_percentage / 100)
            const paidAmount = (amt * clampedPerc) / 100;
            const remaining = amt - paidAmount;
            remainingCtrl.setValue(Number.isFinite(remaining) ? +(remaining.toFixed(2)) : 0, { emitEvent: false });
        };

        const recalcFromRemaining = () => {
            const isType1 = Number(typeCtrl.value) === 1;
            if (!isType1) return;
            const amt = Number(this.paymentForm.get('payment_amount')?.value ?? 0) || 0;
            const rem = Number(remainingCtrl.value ?? 0);
            if (amt <= 0) {
                percentCtrl.setValue(0, { emitEvent: false });
                return;
            }
            // Clamp remaining 0..amt
            const clampedRem = Math.max(0, Math.min(amt, rem));
            if (rem !== clampedRem) remainingCtrl.setValue(clampedRem, { emitEvent: false });
            // NOW: percentage represents PAID percentage, so perc = ((total - remaining) / total) * 100
            const paidAmount = amt - clampedRem;
            const perc = (paidAmount / amt) * 100;
            percentCtrl.setValue(Number.isFinite(perc) ? +(perc.toFixed(2)) : 0, { emitEvent: false });
        };

        // Subscribe with simple reentrancy guard
        let updating = false;
        percentCtrl.valueChanges.subscribe(() => {
            if (updating) return;
            updating = true;
            try { recalcFromPercentage(); } finally { updating = false; }
        });
        remainingCtrl.valueChanges.subscribe(() => {
            if (updating) return;
            updating = true;
            try { recalcFromRemaining(); } finally { updating = false; }
        });

        // When payment amount changes, recompute whichever counterpart exists
        this.paymentForm.get('payment_amount')?.valueChanges.subscribe(() => {
            if (updating) return;
            // Toggle enablement based on amount presence
            togglePartialFields();
            const isType1 = Number(typeCtrl.value) === 1;
            if (!isType1) return;
            updating = true;
            try {
                const hasPerc = percentCtrl.value !== null && percentCtrl.value !== '' && !isNaN(Number(percentCtrl.value));
                const hasRem = remainingCtrl.value !== null && remainingCtrl.value !== '' && !isNaN(Number(remainingCtrl.value));
                if (hasPerc) recalcFromPercentage();
                else if (hasRem) recalcFromRemaining();
            } finally { updating = false; }
        });
        // Trigger initial rules based on current value
        typeCtrl.setValue(typeCtrl.value, { emitEvent: true });
        // Also set initial enable/disable state based on current amount
        togglePartialFields();
        // Update evidence validation based on initial type
        this.updateEvidenceValidation();
    }

    private updateEvidenceValidation() {
        const evidenceCtrl = this.paymentForm.get('evidence_file');
        if (this.typeFormPayment === 2) {
            evidenceCtrl?.setValidators([Validators.required]);
        } else {
            evidenceCtrl?.clearValidators();
        }
        evidenceCtrl?.updateValueAndValidity({ emitEvent: false });
    }

    onEvidenceFileSelected(event: any) {
        const file = event.target.files[0];
        if (file) {
            this.selectedEvidenceFile = file;
            this.evidenceFileUrl = URL.createObjectURL(file);
            this.paymentForm.patchValue({
                evidence_file: file
            });
        }
    }

    previewEvidenceFile() {
        if (this.evidenceFileUrl) {
            window.open(this.evidenceFileUrl, '_blank');
        }
    }

    clearEvidenceFile() {
        this.selectedEvidenceFile = null;
        if (this.evidenceFileUrl) {
            URL.revokeObjectURL(this.evidenceFileUrl);
            this.evidenceFileUrl = null;
        }
        this.paymentForm.patchValue({
            evidence_file: null
        });
    }

    previewPaymentInvoiceFile() {
        if (this.paymentInvoiceFileUrl) {
            window.open(this.paymentInvoiceFileUrl, '_blank');
        }
    }

    clearPaymentInvoiceFile() {
        this.selectedPaymentInvoiceFile = null;
        if (this.paymentInvoiceFileUrl) {
            URL.revokeObjectURL(this.paymentInvoiceFileUrl);
            this.paymentInvoiceFileUrl = null;
        }
    }

    get paymentTypeId(): number {
        return Number(this.paymentForm?.value?.payment_type_id ?? 0);
    }

    getListMaintenance() {
        this.spinner.show()
        this.columnDefsTable()
        this.buildDatasource()
    }

    columnDefsTable() {
        if (['Administrador', 'Supervisor de mantenimiento'].includes(this.role?.name)) {
            this.columnDefs = this.utilsService.getColummForRolAdminOrSupervisor(this.expandedIds, this, this.role?.name);
        } else if (this.role?.name === 'Administrativo') {
            this.columnDefs = this.utilsService.getColummForRolAdministrativo(this.expandedIds, this, this.role?.name);
        } else if (this.role?.name === 'Dirección') {
            this.columnDefs = this.utilsService.getColummForRolDirectivo(this.expandedIds, this, this.role?.name);
        }
    }

    onGridReady(params: any) {
        this.spinner.show()
        if (params && params.api) {
            this.gridApi = params.api as GridApi
        }
        // Configure grid options via API
        try {
            if (this.gridApi) {
                this.gridApi.setGridOption('getRowHeight', this.getRowHeight as any);
                // this.gridApi.setGridOption('statusBar', this.statusBar as any);
                this.gridApi.setGridOption('tooltipShowDelay', this.tooltipShowDelay as any);
                this.gridApi.setGridOption('tooltipHideDelay', this.tooltipHideDelay as any);
                // Avoid jumping to top when setting new rowData
                this.gridApi.setGridOption('suppressScrollOnNewData', true as any);
                // Option A: Disable AG Grid native pagination; we'll paginate via backend and external controls
                this.gridApi.setGridOption('pagination', false);
                this.gridApi.setGridOption('suppressPaginationPanel', true as any);
            }
        } catch {
        }

        // this.buildDatasource();
        this.applyGridSizing();
    }

    private buildDisplayRows(): any[] {
        const out: any[] = [];
        for (const r of this.baseRows) {
            out.push(r);
            if (r && this.expandedIds.has(r.id)) {
                out.push({ __isDetail: true, master: r });
            }
        }
        return out;
    }
    onCellClicked(event: any) {
        if (event.colDef.field === 'id') {
            const row = event?.data;
            if (!row?.__isDetail) {
                // Remember the current index so we can keep it in view after re-render
                const targetIndex = event?.rowIndex ?? 0;
                const id = row?.id;
                if (this.expandedIds.has(id)) this.expandedIds.delete(id); else this.expandedIds.add(id);
                const display = this.buildDisplayRows();
                if (this.gridApi) {
                    this.gridApi.setRowData(display);
                    this.gridApi.resetRowHeights();
                    // Ensure the previously clicked row stays visible (avoid jumping to top)
                    try { this.gridApi.ensureIndexVisible(targetIndex, 'middle'); } catch { }
                    // Give detail renderer time to mount and report its measured height
                    try { setTimeout(() => this.gridApi.onRowHeightChanged(), 0); } catch { }
                    try { setTimeout(() => this.gridApi.onRowHeightChanged(), 120); } catch { }
                }
            }
            return;
        } else {
            if (event.colDef.headerName != 'Acciones') {
                alert()
            }
        }
    }

    private buildDatasource(): void {
        const raw = this.filterForm.getRawValue()
        const {
            ...payload
        } = raw as any
        const currentPage = this.currentPage > 0 ? this.currentPage : 1;
        this.spinner.show();
        this.maintenanceService.getListMaintenance(payload).subscribe(
            (resp: any) => {
                this.baseRows = Array.isArray(resp?.data?.data) ? resp.data.data : [];
                // Extract unit statistics from the response
                if (resp?.unit_statistics) {
                    this.unitStatistics = resp.unit_statistics;
                }
                // Infer if there is next page when backend does not return total
                this.hasNextPage = Array.isArray(resp?.data) && resp.data.length === this.pageSize;
                const display = this.buildDisplayRows();
                if (this.gridApi) {
                    this.gridApi.setRowData(display);
                    this.gridApi.resetRowHeights();
                    try { setTimeout(() => this.gridApi.onRowHeightChanged(), 0); } catch { }
                    try { setTimeout(() => this.gridApi.onRowHeightChanged(), 120); } catch { }
                    if (this.isResponsive) {
                        setTimeout(() => { if (this.gridApi) this.gridApi.autoSizeAllColumns(false); }, 250);
                    }
                }
                this.spinner.hide();
            },
            () => {
                this.spinner.hide();
            }
        );
    }

    onPageSizeChanged(newSize: number | string) {
        const size = typeof newSize === 'string' ? parseInt(newSize, 10) : newSize;
        if (!isNaN(size as number)) {
            this.pageSize = size as number;
            // Reset to first page and rebuild datasource to send updated page/pageSize
            this.currentPage = 1;
            // this.buildDatasource();
        }
    }
    nextPage() {
        if (this.hasNextPage) {
            this.currentPage += 1;
            // this.buildDatasource();
        }
    }

    prevPage() {
        if (this.currentPage > 1) {
            this.currentPage -= 1;
            // this.buildDatasource();
        }
    }
    typeFormPayment: number = 1;
    openModalPayment(data: any, type: number) {
        this.typeFormPayment = type;

        // Reset form and apply defaults each time the modal opens
        if (this.paymentForm) {
            this.paymentForm.reset({
                payment_method_id: '',
                payment_type_id: '',
                payment_amount: '',
                partial_percentage: null,
                remaining_amount: null,
                settlement_date: null,
                evidence_file: null,
            });
            // Clear file selection
            this.clearEvidenceFile();
            // Update evidence validation based on type
            this.updateEvidenceValidation();
            // Ensure valueChanges logic runs
            this.paymentForm.get('payment_type_id')?.setValue('', { emitEvent: true });
            this.paymentForm.get('payment_method_id')?.setValue('', { emitEvent: true });
            this.paymentForm.get('maintenance_request_id')?.setValue(data.id, { emitEvent: true });
        }
        if (type == 2) {
            this.paymentForm.get('payment_amount')!.disable({ emitEvent: true });
            this.paymentForm.get('settlement_date')!.disable({ emitEvent: true });
            if (data.payment_records.length) {
                let advance = data.payment_records.at(-1)
                this.paymentForm.get("payment_amount")!.setValue(advance.remaining_amount, { emitEvent: true })
                this.paymentForm.get("settlement_date")!.setValue(data.payment_request.settlement_date, { emitEvent: true })
            } else {
                this.paymentForm.get('payment_amount')!.setValue(data.payment_request.amount, { emitEvent: true })
                this.paymentForm.get("settlement_date")!.setValue(data.payment_request.settlement_date, { emitEvent: true })
            }
        } else {
            this.paymentForm.get('payment_amount')!.disable({ emitEvent: false });
            this.paymentForm.get("payment_amount")!.setValue(data.supplier.cost, { emitEvent: true })
        }
        $("#modalPayment").modal("show");
    }

    dataSelected: any;
    typeModalChangedStatus: number = 0;

    openModalChangedStatus(data: any, type: number) {
        // Reset form and apply defaults each time the modal opens
        this.dataSelected = data;
        this.selectedStatusId = null;
        this.selectedStatusForDisplay = null;
        this.typeModalChangedStatus = type;

        $("#modalChangedStatus").modal("show");
    }

    submitStatusChange() {
        if (!this.selectedStatusId || !this.dataSelected) return;

        this.spinner.show();
        const payload = {
            maintenance_request_id: this.dataSelected.id,
            maintenance_status_id: this.selectedStatusId
        };

        this.maintenanceService.updateMaintenanceStatus(payload).subscribe(
            (resp: any) => {
                this.spinner.hide();
                $("#modalChangedStatus").modal("hide");

                Swal.fire({
                    icon: 'success',
                    title: 'Estado actualizado',
                    text: 'El estado del mantenimiento ha sido actualizado correctamente!',
                }).then(() => {
                    this.buildDatasource();
                });
            },
            (error: any) => {
                this.spinner.hide();
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Se ha presentado un error al actualizar el estado!',
                });
            }
        );
    }

    // Getter para encontrar el estado seleccionado
    get selectedStatus(): MaintenanceStatus | null {
        if (!this.selectedStatusId) return null;

        const allStatuses = [...this.statusMaintenanceAdministrative, ...this.statusMaintenanceSupervisor];
        return allStatuses.find(status => status.id === this.selectedStatusId) || null;
    }

    downloadPdfReport() {
        this.spinner.show();
        this.maintenanceService.downloadPdfReport().subscribe(
            (response: Blob) => {
                this.spinner.hide();
                // Crear URL para el blob
                const url = window.URL.createObjectURL(response);
                // Crear enlace para descargar
                const link = document.createElement('a');
                link.href = url;
                link.download = `reporte-solicitudes-mantenimiento-${new Date().toISOString().split('T')[0]}.pdf`;
                document.body.appendChild(link);
                link.click();
                // Limpiar
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            },
            (error: any) => {
                this.spinner.hide();
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Se ha presentado un error al descargar el informe PDF!',
                });
            }
        );
    }

    downloadInvoice(data: any) {
        this.spinner.show();
        this.maintenanceService.downloadInvoice(data.id).subscribe(
            (response: Blob) => {
                this.spinner.hide();
                // Crear URL para el blob
                const url = window.URL.createObjectURL(response);
                // Crear enlace para descargar
                const link = document.createElement('a');
                link.href = url;
                link.download = `factura-mantenimiento-${data.id}-${new Date().toISOString().split('T')[0]}.pdf`;
                document.body.appendChild(link);
                link.click();
                // Limpiar
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            },
            (error: any) => {
                this.spinner.hide();
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Se ha presentado un error al descargar la factura!',
                });
            }
        );
    }
    getInvalidFields(formGroup: FormGroup): string[] {
        const invalidFields: string[] = [];

        Object.keys(formGroup.controls).forEach(key => {
            const control = formGroup.get(key);
            if (control && control.invalid) {
                invalidFields.push(key);
            }
        });

        return invalidFields;
    }

    submitPayment() {
        if (!this.paymentForm) return;
        this.paymentForm.markAllAsTouched();
        if (this.paymentForm.invalid) return;
        this.spinner.show();
        const payload = this.paymentForm.getRawValue();
        $("#modalPayment").modal("hide");
        if (this.typeFormPayment === 1) {
            this.sendAddPaymentRequest(payload);
        } else {
            this.sendAddPaymentRecord(payload);
        }
    }
    sendAddPaymentRequest(data: any) {
        this.spinner.show();
        this.maintenanceService.addPaymentRequest(data).subscribe(
            (resp: any) => {
                this.spinner.hide();
                Swal.fire({
                    icon: 'success',
                    title: 'Exitoso',
                    text: 'Se ha creado la solicitud de pago correctamente!',
                }).then(() => {
                    this.buildDatasource();
                });
            },
            (error: any) => {
                this.spinner.hide();
                Swal.fire({
                    icon: 'error',
                    title: 'Error...',
                    text: 'Se ha presentado un error al crear la solicitud de pago!',
                });
            }
        );
    }
    sendAddPaymentRecord(data: any) {
        // Create FormData for file upload
        const formData = new FormData();

        // Append all form fields to FormData
        Object.keys(data).forEach(key => {
            if (data[key] !== null && data[key] !== undefined && data[key] !== '') {
                if (key === 'evidence_file' && data[key] instanceof File) {
                    // Special handling for file
                    formData.append(key, data[key]);
                } else {
                    formData.append(key, data[key].toString());
                }
            }
        });
        this.spinner.show();

        this.maintenanceService.addPaymentRecord(formData).subscribe(
            (resp: any) => {
                this.spinner.hide();
                Swal.fire({
                    icon: 'success',
                    title: 'Exitoso',
                    text: 'Se ha registrado el pago correctamente!',
                }).then(() => {
                    this.buildDatasource();
                });
            },
            (error: any) => {
                this.spinner.hide();
                Swal.fire({
                    icon: 'error',
                    title: 'Error...',
                    text: 'Se ha presentado un error al registrar el pago!',
                });
            }
        );
    }

    openModalCancel(data: any) {
        Swal.fire({
            icon: 'warning',
            title: '¿Estás seguro de cancelar la solicitud?',
            text: 'Esta acción no se puede deshacer.',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            cancelButtonText: 'No',
        }).then((result) => {
            if (result.isConfirmed) {
                this.spinner.show();
                this.cancelMaintenance(data);
            }
        });
    }
    cancelMaintenance(data: any) {
        this.maintenanceService.cancelMaintenance(data.id).subscribe(
            (resp: any) => {
                this.spinner.hide();
                Swal.fire({
                    icon: 'success',
                    title: 'Exitoso',
                    text: 'Se ha cancelado la solicitud correctamente!',
                }).then(() => {
                    this.buildDatasource();
                });
            },
            (error: any) => {
                this.spinner.hide();
                Swal.fire({
                    icon: 'error',
                    title: 'Error...',
                    text: 'Se ha presentado un error al cancelar la solicitud!',
                });
            }
        );
    }
    evidences: any[] = [];
    openModalEvidences(data: any) {
        // Handle both cases: if data is the entire maintenance record or just evidences array
        if (data.evidences) {
            this.evidences = data.evidences;
        } else if (Array.isArray(data)) {
            this.evidences = data;
        } else {
            this.evidences = [];
            console.warn('No se encontraron evidencias en los datos:', data);
        }

        // Debug: check if paths exist
        if (this.evidences && this.evidences.length > 0) {
            this.evidences.forEach((evidence, index) => {
                if (evidence.path) {
                } else {
                    console.warn(`Evidencia ${index + 1} no tiene path:`, evidence);
                }
            });
        } else {
            console.warn('No hay evidencias disponibles o el formato es incorrecto');
        }

        $("#modalEvidences").modal("show");
    }

    maintenanceId: number = 0;
    uploadFilePaymentInvoice(data: any) {
        this.maintenanceId = data.id;
        $("#modalUploadPaymentInvoice").modal("show");
    }

    downloadAllEvidences() {
        if (!this.evidences || this.evidences.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Sin evidencias',
                text: 'No hay evidencias disponibles para descargar.',
            });
            return;
        }

        this.spinner.show();

        // Create ZIP file with all evidences
        const zip = new JSZip();
        const downloadPromises: Promise<void>[] = [];
        let completedDownloads = 0;

        this.evidences.forEach((evidence, index) => {
            if (evidence && evidence.path) {
                // Use relative path that will be proxied through Angular dev server
                const evidenceUrl = '/storage/' + evidence.path;
                const fileName = `evidencia_${index + 1}`;

                // Fetch the file and add it to the ZIP
                const downloadPromise = fetch(evidenceUrl)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`Error al descargar ${fileName}: ${response.statusText}`);
                        }
                        return response.blob();
                    })
                    .then(blob => {
                        // Determine file extension from path or use default
                        const fileExtension = evidence.path.split('.').pop() || 'jpg';
                        const zipFileName = `${fileName}.${fileExtension}`;
                        zip.file(zipFileName, blob);
                    })
                    .catch(error => {
                        console.error('Error descargando evidencia:', error);
                        // Add a text file with error information
                        zip.file(`${fileName}_error.txt`, `Error al descargar el archivo: ${error.message}`);
                    });

                downloadPromises.push(downloadPromise);
            }
        });

        // Wait for all downloads to complete, then create and download the ZIP
        Promise.all(downloadPromises)
            .then(() => {
                return zip.generateAsync({ type: 'blob' });
            })
            .then(zipBlob => {
                this.spinner.hide();
                const zipFileName = `evidencias_mantenimiento_${new Date().toISOString().split('T')[0]}.zip`;
                fileSaver.saveAs(zipBlob, zipFileName);

                Swal.fire({
                    icon: 'success',
                    title: 'ZIP creado exitosamente',
                    html: `Se ha creado el archivo <strong>${zipFileName}</strong> con ${this.evidences.length} evidencia(s).<br>El archivo se descargará automáticamente.`,
                    showConfirmButton: true,
                    confirmButtonText: 'Entendido'
                });
            })
            .catch(error => {
                this.spinner.hide();
                console.error('Error creando ZIP:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo crear el archivo ZIP. Algunos archivos podrían no estar disponibles.',
                });
            });
    }

    onFilesSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        const file = (input.files && input.files[0]) ? input.files[0] : undefined;

        if (file) {
            if (file.type !== 'application/pdf') {
                Swal.fire({
                    icon: 'error',
                    title: 'Tipo de archivo no válido',
                    text: 'Solo se permiten archivos PDF.',
                });
                input.value = '';
                return;
            }

            // Store the selected file
            this.selectedPaymentInvoiceFile = file;
            this.paymentInvoiceFileUrl = URL.createObjectURL(file);

            // Show success message
            Swal.fire({
                icon: 'success',
                title: 'Archivo seleccionado',
                text: `Archivo "${file.name}" seleccionado correctamente.`,
                timer: 2000,
                showConfirmButton: false
            });
        }

        // Reset input so same file can be selected again
        input.value = '';
    }

    paymentsMade: any[] = [];

    openModalPaymentMade(data: any) {
        this.maintenanceId = data.id;
        this.paymentsMade = data.payment_records;
        $("#modalPaymentMaintenance").modal("show");
    }

    sendPaymentInvoice() {
        if (!this.selectedPaymentInvoiceFile) {
            Swal.fire({
                icon: 'warning',
                title: 'Archivo requerido',
                text: 'Debe seleccionar un archivo PDF para subir la factura de pago.',
            });
            return;
        }

        // Create FormData for file upload
        const formData = new FormData();
        formData.append('invoice_file', this.selectedPaymentInvoiceFile);

        this.spinner.show();
        $("#modalUploadPaymentInvoice").modal("hide");

        this.maintenanceService.uploadPaymentInvoice(formData, this.maintenanceId).subscribe(
            (resp: any) => {
                this.spinner.hide();
                Swal.fire({
                    icon: 'success',
                    title: 'Factura subida',
                    text: 'La factura de pago ha sido subida correctamente!',
                }).then(() => {
                    // Clear the selected file after successful upload
                    this.clearPaymentInvoiceFile();
                    this.buildDatasource();
                });
            },
            (error: any) => {
                this.spinner.hide();
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Se ha presentado un error al subir la factura de pago!',
                });
            }
        );
    }
}
